module.exports = __webpack_public_path__ + "f0686b5aa037efca43fcb42bb3a53d0d.png";